export default
  expando: 'event'
  focusEvents:
    focus: 'focusin'
    blur: 'focusout'
  hoverEvents:
    mouseenter: 'mouseover'
    mouseleave: 'mouseout'
  swipeEvents:
    left: 'swipeleft'
    right: 'swiperight'
    up: 'swipeup'
    down: 'swipedown'
  swipeDistance: 10
  keyCodes:
    enter: 13
    tab: 9
    ctrl: 17
    alt: 18
    shift: 16
    esc: 27
    back: 8
    space: 32
    cap: 20
    up: 38
    down: 40
    left: 37
    right: 39
    del: 46
    end: 35
    home: 36
    ins: 45
    pgUp: 33
    pgDown: 34